import React from 'react'
import { WhenModelValue } from '@morningtrain/react-resources'

export default function WhenOrderIsDeliveryNote ({ children, negate = false }) {
  return (
    <WhenModelValue name='status' condition={v => ['completed', 'received', 'unhandled'].includes(v)} negate={negate}>
      {children}
    </WhenModelValue>
  )
}
